var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Reports", path: { name: "admin-reports" } }],
          name: "Inventory Coverage",
          title: _vm.pageTitle,
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center flex-wrap",
                    },
                    [
                      _c("div", { staticClass: "text-muted" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass: "mr-2",
                              attrs: {
                                variant: "primary",
                                title: "Download CSV",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.downloadCsv.apply(null, arguments)
                                },
                              },
                            },
                            [_c("b-icon-download")],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              attrs: {
                                variant: "primary",
                                title: "Reload Report",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.loadReportData.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_c("b-icon-arrow-clockwise")],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-table", {
            attrs: {
              fields: _vm.reportColumns,
              items: _vm.reportRows,
              "table-class": "text-nowrap",
              responsive: "",
              hover: "",
              "show-empty": "",
              "empty-text": "No data found",
            },
            scopedSlots: _vm._u([
              {
                key: "cell(coverage_percent)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "coverage-badge",
                        class: _vm.getCoverageClass(data.item.coverage_percent),
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatPercent(data.item.coverage_percent)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }